module.exports = "/next-static/_next/static/images/block_image_everything_you_need-50643cfc108a9dc4c5813b668c58cb5d.png";